import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cart-popup__content" }
const _hoisted_2 = { class: "cart-popup__header" }
const _hoisted_3 = { class: "cart-popup__header__heading" }
const _hoisted_4 = { class: "cart-popup__header__sub-heading" }
const _hoisted_5 = {
  key: 0,
  class: "cart-popup__header__warning-info"
}
const _hoisted_6 = { class: "cart-popup__main" }
const _hoisted_7 = { class: "cart-popup__main__items-list" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["alt", "src"]
const _hoisted_10 = { class: "cart-popup__main__item__info" }
const _hoisted_11 = { class: "cart-popup__main__item__info-left" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "cart-popup__main__item__art-nr" }
const _hoisted_14 = {
  key: 0,
  class: "cart-popup__main__item__amount-price cart-popup__main__item__amount-price--disabled"
}
const _hoisted_15 = { class: "cart-popup__main__item__info-right" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "cart-popup__main__item__price-container" }
const _hoisted_18 = { class: "cart-popup__main__item__price cart-popup__main__item__price--old" }
const _hoisted_19 = { class: "cart-popup__main__price-container" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "cart-popup__footer" }
const _hoisted_22 = { class: "cart-popup__footer__button-container" }
const _hoisted_23 = ["href"]
const _hoisted_24 = {
  key: 0,
  class: "cart-popup__footer__logos-container"
}
const _hoisted_25 = ["alt", "src"]

import { onMounted, reactive, watch } from "vue";
import { useCart } from "@/store/useCart";
import dictionary from "@/i18n/dictionary.json";
import TressCartAmountSelector from "@/components/TressCartAmountSelector.vue";
import { IIconLink } from "@/models/IIconLink";
import TressCartQuantitySelector from "@/components/TressCartQuantitySelector.vue";
import { IQuantityBreak } from "@/models/IQuantityBreak";
import { CartRow, CartRowItem } from "@/models/Cart";
import { useDebounceFn } from "@vueuse/core";
import { PriceExtensions } from "@/code/PriceExtensions";
import { useCheckout } from "@/store/useCheckout";
import { DataLayerApi } from "@/services/Api";
import { CustomerType } from "@/enums/CustomerType";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressCartPopUp',
  props: {
  isCartPopUpOpen: {
    type: Boolean,
    required: true,
  },
  checkOutPageUrl: {
    type: String,
    required: true,
  },
},
  emits: {
  close: () => {
    return true;
  },
},
  setup(__props, { emit }) {

const props = __props;

const paymentMethods = reactive<Array<IIconLink>>([] as Array<IIconLink>);
const cartStore = useCart();
const checkout = useCheckout();
let closeEventController: AbortController | null;





const itemHasDiscount = (item: CartRowItem) => {
    return cartStore.discountCodeHasBeenApplied || (item.discountPercent && item.discountPercent > 0)
}

const loadPaymentMethodLogos = () => {
  const paymentMethodLogos = document.querySelector("#footer-payment-methods")?.querySelectorAll("img");
  if (paymentMethodLogos) {
    paymentMethodLogos.forEach((img: HTMLImageElement) => {
      paymentMethods.push({
        iconUrl: img.src,
      } as IIconLink);
    });
  }
};

const $t = useI18n().t;
const customerType = window.customerType;
const vatText = () =>
  customerType === CustomerType.Private ? $t(dictionary.common.includeVat) : $t(dictionary.common.excludeVat);

const updateItemQuantity = async (partNo: string, quantity: number) => {
  if (typeof window !== "undefined" && window.BiTracking) {
    window.BiTracking.addToBasket(partNo, quantity, "", cartStore.id, "");
  }
  Promise.all([cartStore.updateQuantityFromCart(partNo, quantity), checkout.clearDeliveryMethod()]);
};

const removeItem = async (partNo: string, quantity: number) => {
  if (typeof window !== "undefined" && window.BiTracking) {
    window.BiTracking.removeFromBasket(partNo);
  }
  DataLayerApi.createRemoveFromCartEvent(partNo, quantity);
  Promise.all([cartStore.removeFromCart(partNo), checkout.clearDeliveryMethod()]);
};

const onCloseClick = () => {
  emit("close");
};

const onAmountClick = (partNo: string, quantity: number) => {
  debouncedUpdateItemQuantity(partNo, quantity);
};

const onQuantityBreakClick = (quantityBreak: IQuantityBreak, row: CartRow) => {
  DataLayerApi.createAddToCartEvent(row.item.partNo, quantityBreak.qtyBreak - row.quantity, "cart-popup");
  debouncedUpdateItemQuantity(row.item.partNo, quantityBreak.qtyBreak);
};

const debouncedUpdateItemQuantity = useDebounceFn((partNo: string, quantity: number) => {
  updateItemQuantity(partNo, quantity);
}, 700);

const tryClose = (ev: MouseEvent) => {
  if (!(ev.target as HTMLElement).closest(".cart-popup, .header__cart, .order-summary__edit")) {
    removeCloseEventListener();
    emit("close");
  }
};

const addCloseEventListener = () => {
  closeEventController = new AbortController();
  document.addEventListener("click", tryClose, { signal: closeEventController.signal });
};

const removeCloseEventListener = () => {
  closeEventController?.abort();
};

watch(
  () => props.isCartPopUpOpen,
  (value) => {
    if (value) {
      addCloseEventListener();
    } else {
      removeCloseEventListener();
    }
  }
);

onMounted(() => {
  loadPaymentMethodLogos();
});

return (_ctx: any,_cache: any) => {
  const _component_icon_close = _resolveComponent("icon-close")!
  const _component_icon_info = _resolveComponent("icon-info")!
  const _component_icon_trash_bin = _resolveComponent("icon-trash-bin")!

  return (_openBlock(), _createElementBlock("dialog", {
    class: _normalizeClass([{ 'cart-popup--show': __props.isCartPopUpOpen }, "cart-popup"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, _toDisplayString(_unref($t)(_unref(dictionary).cart.cart)), 1),
          _createElementVNode("button", {
            class: "cart-popup__header__close-button",
            onClick: onCloseClick
          }, [
            _createVNode(_component_icon_close)
          ])
        ]),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref($t)(_unref(dictionary).cart.amount)) + ": " + _toDisplayString(_unref(cartStore).itemQuantity), 1),
        (_unref(cartStore).hasRemovedItems)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_icon_info),
              _createElementVNode("p", null, _toDisplayString(_unref($t)(_unref(dictionary).cart.warningMessageNotInStock)), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cartStore).rows, (row) => {
            return (_openBlock(), _createElementBlock("li", {
              key: row.item.partNo,
              class: "cart-popup__main__item"
            }, [
              _createElementVNode("a", {
                href: row.item.url,
                class: "cart-popup__main__item__img"
              }, [
                _createElementVNode("img", {
                  alt: row.item.name,
                  src: row.item.imageUrl
                }, null, 8, _hoisted_9)
              ], 8, _hoisted_8),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("a", {
                    href: row.item.url,
                    class: "cart-popup__main__item__name"
                  }, [
                    _createElementVNode("h3", null, _toDisplayString(row.item.name), 1)
                  ], 8, _hoisted_12),
                  _createElementVNode("p", _hoisted_13, _toDisplayString(row.item.partNo), 1),
                  (itemHasDiscount(row.item))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_unref(PriceExtensions).getPriceFormattedByCustomerType(row.item.originalPriceIncVat, row.item.originalPrice)) + "/" + _toDisplayString(_unref($t)(_unref(dictionary).cart.unitOfMeasurement)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", {
                    class: _normalizeClass(["cart-popup__main__item__amount-price", { 'cart-popup__main__item__amount-price--discounted': itemHasDiscount(row.item) }])
                  }, _toDisplayString(_unref(PriceExtensions).getPriceFormattedByCustomerType(row.item.priceIncVat, row.item.price)) + "/" + _toDisplayString(_unref($t)(_unref(dictionary).cart.unitOfMeasurement)), 3),
                  _createVNode(TressCartAmountSelector, {
                    modelValue: row.quantity,
                    "onUpdate:modelValue": [($event: any) => ((row.quantity) = $event), ($event: any) => (onAmountClick(row.item.partNo, row.quantity))],
                    partno: row.item.partNo
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "partno"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("button", {
                    class: "cart-popup__main__item__remove",
                    onClick: ($event: any) => (removeItem(row.item.partNo, row.quantity))
                  }, [
                    _createVNode(_component_icon_trash_bin)
                  ], 8, _hoisted_16),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(PriceExtensions).getPriceFormattedByCustomerType(row.priceIncVat, row.price)), 1)
                  ])
                ])
              ]),
              (row.quantityBreaks.length > 0)
                ? (_openBlock(), _createBlock(TressCartQuantitySelector, {
                    key: 0,
                    quantity: row.quantity,
                    "quantity-breaks": row.quantityBreaks,
                    unitOfMeasurement: row.item.unitOfMeasurement,
                    onClick: (quantityBreak) => onQuantityBreakClick(quantityBreak, row)
                  }, null, 8, ["quantity", "quantity-breaks", "unitOfMeasurement", "onClick"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(_unref($t)(_unref(dictionary).cart.total)), 1),
            _createElementVNode("p", null, _toDisplayString(vatText()), 1)
          ]),
          (_unref(cartStore).summary.originalTotal?.amountIncVat && _unref(cartStore).summary.originalTotal?.amount)
            ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_unref(PriceExtensions).getPriceFormattedByCustomerType(
                _unref(cartStore).summary.total?.amountIncVat,
                _unref(cartStore).summary.total?.amount
              )), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("a", {
            href: __props.checkOutPageUrl,
            class: "button button--default"
          }, _toDisplayString(_unref($t)(_unref(dictionary).cart.goToCheckout)), 9, _hoisted_23)
        ]),
        (paymentMethods.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentMethods, (logo) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: logo.iconUrl
                }, [
                  _createElementVNode("img", {
                    alt: logo.title,
                    src: logo.iconUrl
                  }, null, 8, _hoisted_25)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})